import React from 'react';

const useUpdateEffect = (callback: React.EffectCallback, deps: React.DependencyList) => {
  const mounted = React.useRef<boolean>(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies(callback): [chris hunter] - cb not in deps to avoid unneccissary calls
  React.useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }

    return callback();
  }, deps);
};

export default useUpdateEffect;
